export default "__VITE_ASSET__c4e0f568__"